var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6666 20.1018C36.6666 10.8418 29.2049 3.3335 19.9999 3.3335C10.7949 3.3335 3.33325 10.8418 3.33325 20.1018C3.33325 28.4718 9.42825 35.4085 17.3966 36.6668V24.9502H13.1633V20.1002H17.3966V16.4085C17.3966 12.2052 19.8833 9.8835 23.6916 9.8835C25.5149 9.8835 27.4216 10.2118 27.4216 10.2118V14.3385H25.3216C23.2499 14.3385 22.6049 15.6302 22.6049 16.9552V20.1018H27.2266L26.4883 24.9485H22.6049V36.6668C30.5716 35.4085 36.6666 28.4718 36.6666 20.1018Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fb-icon.4c231e04e3e831b31ce61b1f4f474034.svg";
export { ForwardRef as ReactComponent };